import React from 'react';
import './assets/styles/App.css';
import Westcast24 from './pages/westcast';

function App() {
  return (
    <div className="App">
      <Westcast24/>
    </div>
  );
}

export default App;
